// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"e89117b7","703":"52ac2d38"}[chunkId] + ".chunk.js";
};